/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by routegen.ts
// You should NOT make changes to this file, as it will be overwritten.
// To regenerate, run: bun scripts/routegen.ts

import { Route as rootRoute } from './routes/__root'
import { Route as BlogSlugImport } from './routes/blog/$slug'
import { Route as BlogIndexImport } from './routes/blog/index'
import { Route as BookingFinalizeTokenImport } from './routes/booking/finalize.$token'
import { Route as BookingPaymentResultOutcomeSessionTokenImport } from './routes/booking/payment-result.$outcome.$session.$token'
import { Route as BookingPaymentResultOutcomeSessionImport } from './routes/booking/payment-result.$outcome.$session'
import { Route as BookingPaymentResultImport } from './routes/booking/payment-result'
import { Route as DashboardAdminBlogPostIdEditImport } from './routes/dashboard/admin/blog/$postId/edit'
import { Route as DashboardAdminBlogIndexImport } from './routes/dashboard/admin/blog/index'
import { Route as DashboardAdminBlogNewImport } from './routes/dashboard/admin/blog/new'
import { Route as DashboardAdminCalendarImport } from './routes/dashboard/admin/calendar'
import { Route as DashboardAdminCancellationRequestsImport } from './routes/dashboard/admin/cancellation-requests'
import { Route as DashboardAdminCatalogIndexImport } from './routes/dashboard/admin/catalog/index'
import { Route as DashboardAdminClientsImport } from './routes/dashboard/admin/clients'
import { Route as DashboardAdminCompaniesCompanyIdImport } from './routes/dashboard/admin/companies/$companyId'
import { Route as DashboardAdminCompaniesIndexImport } from './routes/dashboard/admin/companies/index'
import { Route as DashboardAdminContentIndexImport } from './routes/dashboard/admin/content/index'
import { Route as DashboardAdminCountryMultipliersImport } from './routes/dashboard/admin/country-multipliers'
import { Route as DashboardAdminDocumentsDocumentIdImport } from './routes/dashboard/admin/documents/$documentId'
import { Route as DashboardAdminDocumentsIndexImport } from './routes/dashboard/admin/documents/index'
import { Route as DashboardAdminEmailLogsImport } from './routes/dashboard/admin/email-logs'
import { Route as DashboardAdminEnrollmentQuestionnaireImport } from './routes/dashboard/admin/enrollment-questionnaire'
import { Route as DashboardAdminFaqIndexImport } from './routes/dashboard/admin/faq/index'
import { Route as DashboardAdminFiscalizationImport } from './routes/dashboard/admin/fiscalization'
import { Route as DashboardAdminGroupEnrollmentsImport } from './routes/dashboard/admin/group-enrollments'
import { Route as DashboardAdminMediaImport } from './routes/dashboard/admin/media'
import { Route as DashboardAdminPagesPageIdEditImport } from './routes/dashboard/admin/pages/$pageId/edit'
import { Route as DashboardAdminPagesIndexImport } from './routes/dashboard/admin/pages/index'
import { Route as DashboardAdminPagesNewImport } from './routes/dashboard/admin/pages/new'
import { Route as DashboardAdminPayoutsIndexImport } from './routes/dashboard/admin/payouts/index'
import { Route as DashboardAdminRefundsImport } from './routes/dashboard/admin/refunds'
import { Route as DashboardAdminReportsImport } from './routes/dashboard/admin/reports'
import { Route as DashboardAdminReviewsImport } from './routes/dashboard/admin/reviews'
import { Route as DashboardAdminRouteImport } from './routes/dashboard/admin/route'
import { Route as DashboardAdminServicesImport } from './routes/dashboard/admin/services'
import { Route as DashboardAdminSettingsImport } from './routes/dashboard/admin/settings'
import { Route as DashboardAdminSubscriptionsIndexImport } from './routes/dashboard/admin/subscriptions/index'
import { Route as DashboardAdminTestsTestIdImport } from './routes/dashboard/admin/tests/$testId'
import { Route as DashboardAdminTestsIndexImport } from './routes/dashboard/admin/tests/index'
import { Route as DashboardAdminTestsNewImport } from './routes/dashboard/admin/tests/new'
import { Route as DashboardAdminTherapiesImport } from './routes/dashboard/admin/therapies'
import { Route as DashboardAdminTherapistsTherapistIdImport } from './routes/dashboard/admin/therapists/$therapistId'
import { Route as DashboardAdminTherapistsIndexImport } from './routes/dashboard/admin/therapists/index'
import { Route as DashboardAdminVideosVideoIdImport } from './routes/dashboard/admin/videos/$videoId'
import { Route as DashboardAdminVideosIndexImport } from './routes/dashboard/admin/videos/index'
import { Route as DashboardAdminVideosNewImport } from './routes/dashboard/admin/videos/new'
import { Route as DashboardClientGroupTherapiesImport } from './routes/dashboard/client/group-therapies'
import { Route as DashboardClientRouteImport } from './routes/dashboard/client/route'
import { Route as DashboardClientSessionsImport } from './routes/dashboard/client/sessions'
import { Route as DashboardIndexImport } from './routes/dashboard/index'
import { Route as DashboardRouteImport } from './routes/dashboard/route'
import { Route as DashboardSupervisorBillingImport } from './routes/dashboard/supervisor/billing'
import { Route as DashboardSupervisorCreditImport } from './routes/dashboard/supervisor/credit'
import { Route as DashboardSupervisorEmployeesImport } from './routes/dashboard/supervisor/employees'
import { Route as DashboardSupervisorIndexImport } from './routes/dashboard/supervisor/index'
import { Route as DashboardSupervisorRouteImport } from './routes/dashboard/supervisor/route'
import { Route as DashboardSupervisorSessionsImport } from './routes/dashboard/supervisor/sessions'
import { Route as DashboardTherapistBlogPostIdEditImport } from './routes/dashboard/therapist/blog/$postId/edit'
import { Route as DashboardTherapistBlogIndexImport } from './routes/dashboard/therapist/blog/index'
import { Route as DashboardTherapistBlogNewImport } from './routes/dashboard/therapist/blog/new'
import { Route as DashboardTherapistCalendarImport } from './routes/dashboard/therapist/calendar'
import { Route as DashboardTherapistEarningsImport } from './routes/dashboard/therapist/earnings'
import { Route as DashboardTherapistFinancesImport } from './routes/dashboard/therapist/finances'
import { Route as DashboardTherapistGroupTherapiesImport } from './routes/dashboard/therapist/group-therapies'
import { Route as DashboardTherapistIndexImport } from './routes/dashboard/therapist/index'
import { Route as DashboardTherapistOnboardingImport } from './routes/dashboard/therapist/onboarding'
import { Route as DashboardTherapistReviewsImport } from './routes/dashboard/therapist/reviews'
import { Route as DashboardTherapistRouteImport } from './routes/dashboard/therapist/route'
import { Route as DashboardTherapistServicesImport } from './routes/dashboard/therapist/services'
import { Route as DashboardTherapistSettingsImport } from './routes/dashboard/therapist/settings'
import { Route as DashboardTherapistTestsImport } from './routes/dashboard/therapist/tests'
import { Route as DashboardTherapistTherapiesImport } from './routes/dashboard/therapist/therapies'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as GrupneTerapijeIdImport } from './routes/grupne-terapije/$id'
import { Route as GrupneTerapijeIndexImport } from './routes/grupne-terapije/index'
import { Route as GrupneTerapijePaymentResultOutcomeEnrollmentImport } from './routes/grupne-terapije/payment-result.$outcome.$enrollment'
import { Route as GrupneTerapijePaymentResultImport } from './routes/grupne-terapije/payment-result'
import { Route as IndexImport } from './routes/index'
import { Route as KontaktFirmeImport } from './routes/kontakt-firme'
import { Route as KontaktImport } from './routes/kontakt'
import { Route as LoginImport } from './routes/login'
import { Route as OnboardingImport } from './routes/onboarding'
import { Route as PagesSlugImport } from './routes/pages/$slug'
import { Route as PostLoginImport } from './routes/post-login'
import { Route as ProfileImport } from './routes/profile'
import { Route as PronadjiTerapeutaImport } from './routes/pronadji-terapeuta'
import { Route as RegisterImport } from './routes/register'
import { Route as ServicesImport } from './routes/services'
import { Route as SubscriptionPayTokenOutcomeImport } from './routes/subscription/pay.$token.$outcome'
import { Route as SubscriptionPayTokenImport } from './routes/subscription/pay.$token'
import { Route as TestTokenImport } from './routes/test.$token'
import { Route as TherapistEnrollImport } from './routes/therapist-enroll'
import { Route as TherapistsTherapistIdImport } from './routes/therapists/$therapistId'
import { Route as TherapistsIndexImport } from './routes/therapists/index'
import { Route as VideoSlugImport } from './routes/video/$slug'
import { Route as VideoIndexImport } from './routes/video/index'
import { Route as ZaFirmeImport } from './routes/za-firme'
import { Route as ZaTerapeuteImport } from './routes/za-terapeute'

// Create/Update Routes

const BlogSlugRoute = BlogSlugImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRoute,
} as any)

const BlogIndexRoute = BlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRoute,
} as any)

const BookingFinalizeTokenRoute = BookingFinalizeTokenImport.update({
  id: '/booking/finalize/$token',
  path: '/booking/finalize/$token',
  getParentRoute: () => rootRoute,
} as any)

const BookingPaymentResultOutcomeSessionTokenRoute = BookingPaymentResultOutcomeSessionTokenImport.update({
  id: '/booking/payment-result/$outcome/$session/$token',
  path: '/booking/payment-result/$outcome/$session/$token',
  getParentRoute: () => rootRoute,
} as any)

const BookingPaymentResultOutcomeSessionRoute = BookingPaymentResultOutcomeSessionImport.update({
  id: '/booking/payment-result/$outcome/$session',
  path: '/booking/payment-result/$outcome/$session',
  getParentRoute: () => rootRoute,
} as any)

const BookingPaymentResultRoute = BookingPaymentResultImport.update({
  id: '/booking/payment-result',
  path: '/booking/payment-result',
  getParentRoute: () => rootRoute,
} as any)

const DashboardAdminBlogPostIdEditRoute = DashboardAdminBlogPostIdEditImport.update({
  id: '/dashboard/admin/blog/$postId/edit',
  path: '/blog/$postId/edit',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminBlogIndexRoute = DashboardAdminBlogIndexImport.update({
  id: '/dashboard/admin/blog/',
  path: '/blog/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminBlogNewRoute = DashboardAdminBlogNewImport.update({
  id: '/dashboard/admin/blog/new',
  path: '/blog/new',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminCalendarRoute = DashboardAdminCalendarImport.update({
  id: '/dashboard/admin/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminCancellationRequestsRoute = DashboardAdminCancellationRequestsImport.update({
  id: '/dashboard/admin/cancellation-requests',
  path: '/cancellation-requests',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminCatalogIndexRoute = DashboardAdminCatalogIndexImport.update({
  id: '/dashboard/admin/catalog/',
  path: '/catalog/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminClientsRoute = DashboardAdminClientsImport.update({
  id: '/dashboard/admin/clients',
  path: '/clients',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminCompaniesCompanyIdRoute = DashboardAdminCompaniesCompanyIdImport.update({
  id: '/dashboard/admin/companies/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminCompaniesIndexRoute = DashboardAdminCompaniesIndexImport.update({
  id: '/dashboard/admin/companies/',
  path: '/companies/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminContentIndexRoute = DashboardAdminContentIndexImport.update({
  id: '/dashboard/admin/content/',
  path: '/content/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminCountryMultipliersRoute = DashboardAdminCountryMultipliersImport.update({
  id: '/dashboard/admin/country-multipliers',
  path: '/country-multipliers',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminDocumentsDocumentIdRoute = DashboardAdminDocumentsDocumentIdImport.update({
  id: '/dashboard/admin/documents/$documentId',
  path: '/documents/$documentId',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminDocumentsIndexRoute = DashboardAdminDocumentsIndexImport.update({
  id: '/dashboard/admin/documents/',
  path: '/documents/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminEmailLogsRoute = DashboardAdminEmailLogsImport.update({
  id: '/dashboard/admin/email-logs',
  path: '/email-logs',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminEnrollmentQuestionnaireRoute = DashboardAdminEnrollmentQuestionnaireImport.update({
  id: '/dashboard/admin/enrollment-questionnaire',
  path: '/enrollment-questionnaire',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminFaqIndexRoute = DashboardAdminFaqIndexImport.update({
  id: '/dashboard/admin/faq/',
  path: '/faq/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminFiscalizationRoute = DashboardAdminFiscalizationImport.update({
  id: '/dashboard/admin/fiscalization',
  path: '/fiscalization',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminGroupEnrollmentsRoute = DashboardAdminGroupEnrollmentsImport.update({
  id: '/dashboard/admin/group-enrollments',
  path: '/group-enrollments',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminMediaRoute = DashboardAdminMediaImport.update({
  id: '/dashboard/admin/media',
  path: '/media',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminPagesPageIdEditRoute = DashboardAdminPagesPageIdEditImport.update({
  id: '/dashboard/admin/pages/$pageId/edit',
  path: '/pages/$pageId/edit',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminPagesIndexRoute = DashboardAdminPagesIndexImport.update({
  id: '/dashboard/admin/pages/',
  path: '/pages/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminPagesNewRoute = DashboardAdminPagesNewImport.update({
  id: '/dashboard/admin/pages/new',
  path: '/pages/new',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminPayoutsIndexRoute = DashboardAdminPayoutsIndexImport.update({
  id: '/dashboard/admin/payouts/',
  path: '/payouts/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminRefundsRoute = DashboardAdminRefundsImport.update({
  id: '/dashboard/admin/refunds',
  path: '/refunds',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminReportsRoute = DashboardAdminReportsImport.update({
  id: '/dashboard/admin/reports',
  path: '/reports',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminReviewsRoute = DashboardAdminReviewsImport.update({
  id: '/dashboard/admin/reviews',
  path: '/reviews',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminRouteRoute = DashboardAdminRouteImport.update({
  id: '/dashboard/admin',
  path: '/admin',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardAdminServicesRoute = DashboardAdminServicesImport.update({
  id: '/dashboard/admin/services',
  path: '/services',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminSettingsRoute = DashboardAdminSettingsImport.update({
  id: '/dashboard/admin/settings',
  path: '/settings',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminSubscriptionsIndexRoute = DashboardAdminSubscriptionsIndexImport.update({
  id: '/dashboard/admin/subscriptions/',
  path: '/subscriptions/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminTestsTestIdRoute = DashboardAdminTestsTestIdImport.update({
  id: '/dashboard/admin/tests/$testId',
  path: '/tests/$testId',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminTestsIndexRoute = DashboardAdminTestsIndexImport.update({
  id: '/dashboard/admin/tests/',
  path: '/tests/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminTestsNewRoute = DashboardAdminTestsNewImport.update({
  id: '/dashboard/admin/tests/new',
  path: '/tests/new',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminTherapiesRoute = DashboardAdminTherapiesImport.update({
  id: '/dashboard/admin/therapies',
  path: '/therapies',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminTherapistsTherapistIdRoute = DashboardAdminTherapistsTherapistIdImport.update({
  id: '/dashboard/admin/therapists/$therapistId',
  path: '/therapists/$therapistId',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminTherapistsIndexRoute = DashboardAdminTherapistsIndexImport.update({
  id: '/dashboard/admin/therapists/',
  path: '/therapists/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminVideosVideoIdRoute = DashboardAdminVideosVideoIdImport.update({
  id: '/dashboard/admin/videos/$videoId',
  path: '/videos/$videoId',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminVideosIndexRoute = DashboardAdminVideosIndexImport.update({
  id: '/dashboard/admin/videos/',
  path: '/videos/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardAdminVideosNewRoute = DashboardAdminVideosNewImport.update({
  id: '/dashboard/admin/videos/new',
  path: '/videos/new',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)

const DashboardClientGroupTherapiesRoute = DashboardClientGroupTherapiesImport.update({
  id: '/dashboard/client/group-therapies',
  path: '/group-therapies',
  getParentRoute: () => DashboardClientRouteRoute,
} as any)

const DashboardClientRouteRoute = DashboardClientRouteImport.update({
  id: '/dashboard/client',
  path: '/client',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardClientSessionsRoute = DashboardClientSessionsImport.update({
  id: '/dashboard/client/sessions',
  path: '/sessions',
  getParentRoute: () => DashboardClientRouteRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  id: '/dashboard/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardRouteRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSupervisorBillingRoute = DashboardSupervisorBillingImport.update({
  id: '/dashboard/supervisor/billing',
  path: '/billing',
  getParentRoute: () => DashboardSupervisorRouteRoute,
} as any)

const DashboardSupervisorCreditRoute = DashboardSupervisorCreditImport.update({
  id: '/dashboard/supervisor/credit',
  path: '/credit',
  getParentRoute: () => DashboardSupervisorRouteRoute,
} as any)

const DashboardSupervisorEmployeesRoute = DashboardSupervisorEmployeesImport.update({
  id: '/dashboard/supervisor/employees',
  path: '/employees',
  getParentRoute: () => DashboardSupervisorRouteRoute,
} as any)

const DashboardSupervisorIndexRoute = DashboardSupervisorIndexImport.update({
  id: '/dashboard/supervisor/',
  path: '/',
  getParentRoute: () => DashboardSupervisorRouteRoute,
} as any)

const DashboardSupervisorRouteRoute = DashboardSupervisorRouteImport.update({
  id: '/dashboard/supervisor',
  path: '/supervisor',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardSupervisorSessionsRoute = DashboardSupervisorSessionsImport.update({
  id: '/dashboard/supervisor/sessions',
  path: '/sessions',
  getParentRoute: () => DashboardSupervisorRouteRoute,
} as any)

const DashboardTherapistBlogPostIdEditRoute = DashboardTherapistBlogPostIdEditImport.update({
  id: '/dashboard/therapist/blog/$postId/edit',
  path: '/blog/$postId/edit',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistBlogIndexRoute = DashboardTherapistBlogIndexImport.update({
  id: '/dashboard/therapist/blog/',
  path: '/blog/',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistBlogNewRoute = DashboardTherapistBlogNewImport.update({
  id: '/dashboard/therapist/blog/new',
  path: '/blog/new',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistCalendarRoute = DashboardTherapistCalendarImport.update({
  id: '/dashboard/therapist/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistEarningsRoute = DashboardTherapistEarningsImport.update({
  id: '/dashboard/therapist/earnings',
  path: '/earnings',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistFinancesRoute = DashboardTherapistFinancesImport.update({
  id: '/dashboard/therapist/finances',
  path: '/finances',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistGroupTherapiesRoute = DashboardTherapistGroupTherapiesImport.update({
  id: '/dashboard/therapist/group-therapies',
  path: '/group-therapies',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistIndexRoute = DashboardTherapistIndexImport.update({
  id: '/dashboard/therapist/',
  path: '/',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistOnboardingRoute = DashboardTherapistOnboardingImport.update({
  id: '/dashboard/therapist/onboarding',
  path: '/onboarding',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistReviewsRoute = DashboardTherapistReviewsImport.update({
  id: '/dashboard/therapist/reviews',
  path: '/reviews',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistRouteRoute = DashboardTherapistRouteImport.update({
  id: '/dashboard/therapist',
  path: '/therapist',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardTherapistServicesRoute = DashboardTherapistServicesImport.update({
  id: '/dashboard/therapist/services',
  path: '/services',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistSettingsRoute = DashboardTherapistSettingsImport.update({
  id: '/dashboard/therapist/settings',
  path: '/settings',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistTestsRoute = DashboardTherapistTestsImport.update({
  id: '/dashboard/therapist/tests',
  path: '/tests',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const DashboardTherapistTherapiesRoute = DashboardTherapistTherapiesImport.update({
  id: '/dashboard/therapist/therapies',
  path: '/therapies',
  getParentRoute: () => DashboardTherapistRouteRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const GrupneTerapijeIdRoute = GrupneTerapijeIdImport.update({
  id: '/grupne-terapije/$id',
  path: '/grupne-terapije/$id',
  getParentRoute: () => rootRoute,
} as any)

const GrupneTerapijeIndexRoute = GrupneTerapijeIndexImport.update({
  id: '/grupne-terapije/',
  path: '/grupne-terapije/',
  getParentRoute: () => rootRoute,
} as any)

const GrupneTerapijePaymentResultOutcomeEnrollmentRoute = GrupneTerapijePaymentResultOutcomeEnrollmentImport.update({
  id: '/grupne-terapije/payment-result/$outcome/$enrollment',
  path: '/grupne-terapije/payment-result/$outcome/$enrollment',
  getParentRoute: () => rootRoute,
} as any)

const GrupneTerapijePaymentResultRoute = GrupneTerapijePaymentResultImport.update({
  id: '/grupne-terapije/payment-result',
  path: '/grupne-terapije/payment-result',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const KontaktFirmeRoute = KontaktFirmeImport.update({
  id: '/kontakt-firme',
  path: '/kontakt-firme',
  getParentRoute: () => rootRoute,
} as any)

const KontaktRoute = KontaktImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingRoute = OnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const PagesSlugRoute = PagesSlugImport.update({
  id: '/pages/$slug',
  path: '/pages/$slug',
  getParentRoute: () => rootRoute,
} as any)

const PostLoginRoute = PostLoginImport.update({
  id: '/post-login',
  path: '/post-login',
  getParentRoute: () => rootRoute,
} as any)

const ProfileRoute = ProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRoute,
} as any)

const PronadjiTerapeutaRoute = PronadjiTerapeutaImport.update({
  id: '/pronadji-terapeuta',
  path: '/pronadji-terapeuta',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const ServicesRoute = ServicesImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionPayTokenOutcomeRoute = SubscriptionPayTokenOutcomeImport.update({
  id: '/subscription/pay/$token/$outcome',
  path: '/subscription/pay/$token/$outcome',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionPayTokenRoute = SubscriptionPayTokenImport.update({
  id: '/subscription/pay/$token',
  path: '/subscription/pay/$token',
  getParentRoute: () => rootRoute,
} as any)

const TestTokenRoute = TestTokenImport.update({
  id: '/test/$token',
  path: '/test/$token',
  getParentRoute: () => rootRoute,
} as any)

const TherapistEnrollRoute = TherapistEnrollImport.update({
  id: '/therapist-enroll',
  path: '/therapist-enroll',
  getParentRoute: () => rootRoute,
} as any)

const TherapistsTherapistIdRoute = TherapistsTherapistIdImport.update({
  id: '/therapists/$therapistId',
  path: '/therapists/$therapistId',
  getParentRoute: () => rootRoute,
} as any)

const TherapistsIndexRoute = TherapistsIndexImport.update({
  id: '/therapists/',
  path: '/therapists/',
  getParentRoute: () => rootRoute,
} as any)

const VideoSlugRoute = VideoSlugImport.update({
  id: '/video/$slug',
  path: '/video/$slug',
  getParentRoute: () => rootRoute,
} as any)

const VideoIndexRoute = VideoIndexImport.update({
  id: '/video/',
  path: '/video/',
  getParentRoute: () => rootRoute,
} as any)

const ZaFirmeRoute = ZaFirmeImport.update({
  id: '/za-firme',
  path: '/za-firme',
  getParentRoute: () => rootRoute,
} as any)

const ZaTerapeuteRoute = ZaTerapeuteImport.update({
  id: '/za-terapeute',
  path: '/za-terapeute',
  getParentRoute: () => rootRoute,
} as any)

// Build route tree

const DashboardSupervisorRouteRouteWithChildren = DashboardSupervisorRouteRoute._addFileChildren({
  DashboardSupervisorBillingRoute: DashboardSupervisorBillingRoute,
  DashboardSupervisorCreditRoute: DashboardSupervisorCreditRoute,
  DashboardSupervisorEmployeesRoute: DashboardSupervisorEmployeesRoute,
  DashboardSupervisorIndexRoute: DashboardSupervisorIndexRoute,
  DashboardSupervisorSessionsRoute: DashboardSupervisorSessionsRoute,
})

const DashboardTherapistRouteRouteWithChildren = DashboardTherapistRouteRoute._addFileChildren({
  DashboardTherapistBlogPostIdEditRoute: DashboardTherapistBlogPostIdEditRoute,
  DashboardTherapistBlogIndexRoute: DashboardTherapistBlogIndexRoute,
  DashboardTherapistBlogNewRoute: DashboardTherapistBlogNewRoute,
  DashboardTherapistCalendarRoute: DashboardTherapistCalendarRoute,
  DashboardTherapistEarningsRoute: DashboardTherapistEarningsRoute,
  DashboardTherapistFinancesRoute: DashboardTherapistFinancesRoute,
  DashboardTherapistGroupTherapiesRoute: DashboardTherapistGroupTherapiesRoute,
  DashboardTherapistIndexRoute: DashboardTherapistIndexRoute,
  DashboardTherapistOnboardingRoute: DashboardTherapistOnboardingRoute,
  DashboardTherapistReviewsRoute: DashboardTherapistReviewsRoute,
  DashboardTherapistServicesRoute: DashboardTherapistServicesRoute,
  DashboardTherapistSettingsRoute: DashboardTherapistSettingsRoute,
  DashboardTherapistTestsRoute: DashboardTherapistTestsRoute,
  DashboardTherapistTherapiesRoute: DashboardTherapistTherapiesRoute,
})

const DashboardClientRouteRouteWithChildren = DashboardClientRouteRoute._addFileChildren({
  DashboardClientGroupTherapiesRoute: DashboardClientGroupTherapiesRoute,
  DashboardClientSessionsRoute: DashboardClientSessionsRoute,
})

const DashboardAdminRouteRouteWithChildren = DashboardAdminRouteRoute._addFileChildren({
  DashboardAdminBlogPostIdEditRoute: DashboardAdminBlogPostIdEditRoute,
  DashboardAdminBlogIndexRoute: DashboardAdminBlogIndexRoute,
  DashboardAdminBlogNewRoute: DashboardAdminBlogNewRoute,
  DashboardAdminCalendarRoute: DashboardAdminCalendarRoute,
  DashboardAdminCancellationRequestsRoute: DashboardAdminCancellationRequestsRoute,
  DashboardAdminCatalogIndexRoute: DashboardAdminCatalogIndexRoute,
  DashboardAdminClientsRoute: DashboardAdminClientsRoute,
  DashboardAdminCompaniesCompanyIdRoute: DashboardAdminCompaniesCompanyIdRoute,
  DashboardAdminCompaniesIndexRoute: DashboardAdminCompaniesIndexRoute,
  DashboardAdminContentIndexRoute: DashboardAdminContentIndexRoute,
  DashboardAdminCountryMultipliersRoute: DashboardAdminCountryMultipliersRoute,
  DashboardAdminDocumentsDocumentIdRoute: DashboardAdminDocumentsDocumentIdRoute,
  DashboardAdminDocumentsIndexRoute: DashboardAdminDocumentsIndexRoute,
  DashboardAdminEmailLogsRoute: DashboardAdminEmailLogsRoute,
  DashboardAdminEnrollmentQuestionnaireRoute: DashboardAdminEnrollmentQuestionnaireRoute,
  DashboardAdminFaqIndexRoute: DashboardAdminFaqIndexRoute,
  DashboardAdminFiscalizationRoute: DashboardAdminFiscalizationRoute,
  DashboardAdminGroupEnrollmentsRoute: DashboardAdminGroupEnrollmentsRoute,
  DashboardAdminMediaRoute: DashboardAdminMediaRoute,
  DashboardAdminPagesPageIdEditRoute: DashboardAdminPagesPageIdEditRoute,
  DashboardAdminPagesIndexRoute: DashboardAdminPagesIndexRoute,
  DashboardAdminPagesNewRoute: DashboardAdminPagesNewRoute,
  DashboardAdminPayoutsIndexRoute: DashboardAdminPayoutsIndexRoute,
  DashboardAdminRefundsRoute: DashboardAdminRefundsRoute,
  DashboardAdminReportsRoute: DashboardAdminReportsRoute,
  DashboardAdminReviewsRoute: DashboardAdminReviewsRoute,
  DashboardAdminServicesRoute: DashboardAdminServicesRoute,
  DashboardAdminSettingsRoute: DashboardAdminSettingsRoute,
  DashboardAdminSubscriptionsIndexRoute: DashboardAdminSubscriptionsIndexRoute,
  DashboardAdminTestsTestIdRoute: DashboardAdminTestsTestIdRoute,
  DashboardAdminTestsIndexRoute: DashboardAdminTestsIndexRoute,
  DashboardAdminTestsNewRoute: DashboardAdminTestsNewRoute,
  DashboardAdminTherapiesRoute: DashboardAdminTherapiesRoute,
  DashboardAdminTherapistsTherapistIdRoute: DashboardAdminTherapistsTherapistIdRoute,
  DashboardAdminTherapistsIndexRoute: DashboardAdminTherapistsIndexRoute,
  DashboardAdminVideosVideoIdRoute: DashboardAdminVideosVideoIdRoute,
  DashboardAdminVideosIndexRoute: DashboardAdminVideosIndexRoute,
  DashboardAdminVideosNewRoute: DashboardAdminVideosNewRoute,
})

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren({
  DashboardAdminRouteRoute: DashboardAdminRouteRouteWithChildren,
  DashboardClientRouteRoute: DashboardClientRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardSupervisorRouteRoute: DashboardSupervisorRouteRouteWithChildren,
  DashboardTherapistRouteRoute: DashboardTherapistRouteRouteWithChildren,
})

const rootRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
  BookingFinalizeTokenRoute: BookingFinalizeTokenRoute,
  BookingPaymentResultOutcomeSessionTokenRoute: BookingPaymentResultOutcomeSessionTokenRoute,
  BookingPaymentResultOutcomeSessionRoute: BookingPaymentResultOutcomeSessionRoute,
  BookingPaymentResultRoute: BookingPaymentResultRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GrupneTerapijeIdRoute: GrupneTerapijeIdRoute,
  GrupneTerapijeIndexRoute: GrupneTerapijeIndexRoute,
  GrupneTerapijePaymentResultOutcomeEnrollmentRoute: GrupneTerapijePaymentResultOutcomeEnrollmentRoute,
  GrupneTerapijePaymentResultRoute: GrupneTerapijePaymentResultRoute,
  IndexRoute: IndexRoute,
  KontaktFirmeRoute: KontaktFirmeRoute,
  KontaktRoute: KontaktRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  PagesSlugRoute: PagesSlugRoute,
  PostLoginRoute: PostLoginRoute,
  ProfileRoute: ProfileRoute,
  PronadjiTerapeutaRoute: PronadjiTerapeutaRoute,
  RegisterRoute: RegisterRoute,
  ServicesRoute: ServicesRoute,
  SubscriptionPayTokenOutcomeRoute: SubscriptionPayTokenOutcomeRoute,
  SubscriptionPayTokenRoute: SubscriptionPayTokenRoute,
  TestTokenRoute: TestTokenRoute,
  TherapistEnrollRoute: TherapistEnrollRoute,
  TherapistsTherapistIdRoute: TherapistsTherapistIdRoute,
  TherapistsIndexRoute: TherapistsIndexRoute,
  VideoSlugRoute: VideoSlugRoute,
  VideoIndexRoute: VideoIndexRoute,
  ZaFirmeRoute: ZaFirmeRoute,
  ZaTerapeuteRoute: ZaTerapeuteRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<any>()
